"use strict";
/* eslint-disable max-len */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConnectionNotOpen = exports.GettingDataFailed = exports.SendFailed = exports.DhtJoinTimeout = exports.ConnectionLocker = exports.ConnectivityResponseTimeout = exports.IllegalArguments = exports.IllegalRtcPeerConnectionState = exports.NotImplemented = exports.CannotConnectToSelf = exports.CouldNotStop = exports.CouldNotStart = exports.WebsocketConnectionRequestRejected = exports.WebsocketServerStartError = exports.CouldNotRoute = exports.ConnectionFailed = exports.ErrorCode = void 0;
var ErrorCode;
(function (ErrorCode) {
    ErrorCode["CONNECTION_FAILED"] = "CONNECTION_FAILED";
    ErrorCode["COULD_NOT_ROUTE"] = "COULD_NOT_ROUTE";
    ErrorCode["STARTING_WEBSOCKET_SERVER_FAILED"] = "STARTING_WEBSOCKET_SERVER_FAILED";
    ErrorCode["WEBSOCKET_CONNECTION_REQUEST_REJECTED"] = "WEBSOCKET_CONNECTION_REQUEST_REJECTED";
    ErrorCode["COULD_NOT_START"] = "COULD_NOT_START";
    ErrorCode["COULD_NOT_STOP"] = "COULD_NOT_STOP";
    ErrorCode["CANNOT_CONNECT_TO_SELF"] = "CANNOT_CONNECT_TO_SELF";
    ErrorCode["NOT_IMPLEMENTED"] = "NOT_IMPLEMENTED";
    ErrorCode["ILLEGAL_RTC_PEER_CONNECTION_STATE"] = "ILLEGAL_RTC_PEER_CONNECTION_STATE";
    ErrorCode["ILLEGAL_ARGUMENTS"] = "ILLEGAL_ARGUMENTS";
    ErrorCode["CONNECTIVITY_RESPONSE_NOT_RECEIVED_BEFORE_TIMEOUT"] = "CONNECTIVITY_RESPONSE_NOT_RECEIVED_BEFORE_TIMEOUT";
    ErrorCode["CONNECTION_LOCKER"] = "CONNECTION_LOCKER";
    ErrorCode["DHT_JOIN_TIMEOUT"] = "DHT_JOIN_TIMEOUT";
    ErrorCode["SEND_FAILED"] = "SEND_FAILED";
    ErrorCode["GETTING_DATA_FAILED"] = "GETTING_DATA_FAILED";
    ErrorCode["CONNECTION_NOT_OPEN"] = "CONNECTION_NOT_OPEN";
})(ErrorCode || (exports.ErrorCode = ErrorCode = {}));
class Err extends Error {
    code;
    originalError;
    constructor(code, message, originalError) {
        super(message);
        this.code = code;
        this.originalError = originalError;
    }
}
class ConnectionFailed extends Err {
    constructor(message, originalError) { super(ErrorCode.CONNECTION_FAILED, message, originalError); }
}
exports.ConnectionFailed = ConnectionFailed;
class CouldNotRoute extends Err {
    constructor(message, originalError) { super(ErrorCode.COULD_NOT_ROUTE, message, originalError); }
}
exports.CouldNotRoute = CouldNotRoute;
class WebsocketServerStartError extends Err {
    constructor(message, originalError) { super(ErrorCode.STARTING_WEBSOCKET_SERVER_FAILED, message, originalError); }
}
exports.WebsocketServerStartError = WebsocketServerStartError;
class WebsocketConnectionRequestRejected extends Err {
    constructor(message, originalError) { super(ErrorCode.WEBSOCKET_CONNECTION_REQUEST_REJECTED, message, originalError); }
}
exports.WebsocketConnectionRequestRejected = WebsocketConnectionRequestRejected;
class CouldNotStart extends Err {
    constructor(message, originalError) { super(ErrorCode.COULD_NOT_START, message, originalError); }
}
exports.CouldNotStart = CouldNotStart;
class CouldNotStop extends Err {
    constructor(message, originalError) { super(ErrorCode.COULD_NOT_STOP, message, originalError); }
}
exports.CouldNotStop = CouldNotStop;
class CannotConnectToSelf extends Err {
    constructor(message, originalError) { super(ErrorCode.CANNOT_CONNECT_TO_SELF, message, originalError); }
}
exports.CannotConnectToSelf = CannotConnectToSelf;
class NotImplemented extends Err {
    constructor(message, originalError) { super(ErrorCode.NOT_IMPLEMENTED, message, originalError); }
}
exports.NotImplemented = NotImplemented;
class IllegalRtcPeerConnectionState extends Err {
    constructor(message, originalError) { super(ErrorCode.ILLEGAL_RTC_PEER_CONNECTION_STATE, message, originalError); }
}
exports.IllegalRtcPeerConnectionState = IllegalRtcPeerConnectionState;
class IllegalArguments extends Err {
    constructor(message, originalError) { super(ErrorCode.ILLEGAL_ARGUMENTS, message, originalError); }
}
exports.IllegalArguments = IllegalArguments;
class ConnectivityResponseTimeout extends Err {
    constructor(message, originalError) { super(ErrorCode.CONNECTIVITY_RESPONSE_NOT_RECEIVED_BEFORE_TIMEOUT, message, originalError); }
}
exports.ConnectivityResponseTimeout = ConnectivityResponseTimeout;
class ConnectionLocker extends Err {
    constructor(message, originalError) { super(ErrorCode.CONNECTION_LOCKER, message, originalError); }
}
exports.ConnectionLocker = ConnectionLocker;
class DhtJoinTimeout extends Err {
    constructor(message, originalError) { super(ErrorCode.DHT_JOIN_TIMEOUT, message, originalError); }
}
exports.DhtJoinTimeout = DhtJoinTimeout;
class SendFailed extends Err {
    constructor(message, originalError) { super(ErrorCode.SEND_FAILED, message, originalError); }
}
exports.SendFailed = SendFailed;
class GettingDataFailed extends Err {
    constructor(message, originalError) { super(ErrorCode.GETTING_DATA_FAILED, message, originalError); }
}
exports.GettingDataFailed = GettingDataFailed;
class ConnectionNotOpen extends Err {
    constructor(message, originalError) { super(ErrorCode.CONNECTION_NOT_OPEN, message, originalError); }
}
exports.ConnectionNotOpen = ConnectionNotOpen;
//# sourceMappingURL=errors.js.map